module.exports = __webpack_public_path__ + "static/media/rules.e397a4d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/rules.png
// module id = 1060
// module chunks = 0